import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="sheet"
export default class extends Controller {
    static targets = ["trigger"]

    triggerTargetConnected(/** @type {HTMLElement} */element) {
        element.addEventListener("click", this.#onTriggerClick)
    }

    triggerTargetDisconnected(/** @type {HTMLElement} */element) {
        element.removeEventListener("click", this.#onTriggerClick)
    }

    toggle() {
        this.#isOpen ? this.#close() : this.#open()
    }

	dispatchToggle() {
		this.dispatch("toggle")
	}

	#onTriggerClick = () => this.toggle()

    #open() {
        this.element.classList.add("sheet--open")
        this.dispatch("open")
    }

    #close() {
        this.element.classList.remove("sheet--open")
        this.dispatch("close")
    }

    get #isOpen() {
        return this.element.classList.contains("sheet--open")
    }
}
